import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { useRecoilState, useRecoilValue } from "recoil";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import styled from "styled-components";
import ConfirmModal from "../../components/modal/ConfirmModal";
import SelectOptionModal from "../../components/modal/optionModal/OptionModal";
import ProductDetailModal from "../../components/modal/optionModal/ProductDetailModal";
import SelectSetOptionModal from "../../components/modal/optionModal/SetOptionModal";
import OrderController, {
  InputRentalType,
} from "../../controller/OrderController";
import {
  badgeType,
  CategoryType,
  optionGroupType,
  pickGroupListType,
  ProductType,
  SetMenuGroupType,
  storeDetailType,
  storeImageType,
  storeType,
} from "../../controller/StoreController";
import { useToast } from "../../controller/ToastController";
import { cartState } from "../../recoil/cart";
import {
  LANG_CH,
  LANG_JP,
  LANG_KO,
  langState,
  langText,
} from "../../recoil/lang";
import {
  orderDetailRealmType,
  PRODUCT_TYPE_EXTENSION,
  PRODUCT_TYPE_RENTAL_DIRECT,
  PRODUCT_TYPE_RENTAL_SMS,
} from "../../recoil/type";

import { useLocation } from "react-router-dom";
import RentalOptionModal from "../../components/modal/RentalOptionModal";
import LogController from "../../controller/LogController";
import { confirmState, ConfirmType } from "../../recoil/confirm";
import { PlayClickAudio } from "../../utils/Audio";
import {
  contentName,
  formatPhoneNumber,
  getCategoryName,
  getOptionTypeName,
  getPrdDescription,
  getPrdName,
  getStoreDetail,
  getStoreEvent,
  getStoreNoti,
} from "../../utils/util";
import ApiController from "../../controller/ApiController";

type MenuInfoProps = {
  storeId: number;
  menuInfo: CategoryType[];
  storeInfo: storeType | undefined;
  storeDetailInfo: storeDetailType[];
  zoom: boolean;
  isCheckAdult: boolean;
  setIsCheckAdult: any;
  resetTimer: any;
  scrollTop?: boolean;
  setScrollTop?: any;
};

let timer: any;

const MenuInfo = ({
  storeId,
  menuInfo,
  storeInfo,
  storeDetailInfo,
  zoom,
  isCheckAdult,
  setIsCheckAdult,
  resetTimer,
  scrollTop,
  setScrollTop,
}: MenuInfoProps) => {
  const location = useLocation();
  const showToast = useToast();
  const scrollRef = useRef<HTMLDivElement>(null);
  const childRef = useRef<HTMLDivElement>(null);
  const [selectedProduct, setSelectedProduct] = useState<ProductType | null>();
  const [selectedCategory, setSelectedCategory] = useState<number>(0);
  const [selectedOption, setSelectedOption] = useState<number[][]>([]);
  const [optionGroupList, setOptionGroupList] = useState<optionGroupType[]>([]);
  const [setMenuGroupList, setSetMenuGroupList] = useState<
    SetMenuGroupType | undefined
  >();
  const [isOptionModalVisible, setIsOptionModalVisible] =
    useState<boolean>(false);
  const [setOptionModalVisible, setSetOptionModalVisible] =
    useState<boolean>(false);
  const [rentalOptionModalVisible, setRentalOptionModalVisible] =
    useState<boolean>(false);
  const [isProductDetailModalVisible, setIsProductDetailModalVisible] =
    useState<boolean>(false);

  const [isScroll, setIsScroll] = useState<boolean>(false);
  const [lang, setLang] = useRecoilState<number>(langState);
  const [storeInfoIndex, setStoreInfoIndex] = useState<number[]>([]);
  const cart = useRecoilValue<orderDetailRealmType[]>(cartState);
  const [currentConfirmState, setConfirmState] =
    useRecoilState<ConfirmType>(confirmState);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const [rentalTime, setRentalTime] = useState<InputRentalType>({
    option_type_name: "",
    option_name: "",
  });

  // 카테고리
  const selectCategory = (index: number) => {
    setSelectedCategory(index);
    const selectedElement = scrollRef.current?.children[index] as
      | HTMLDivElement
      | undefined;

    setIsScroll(true);

    clearTimeout(timer);
    timer = setTimeout(() => setIsScroll(false), 1300);

    if (selectedElement) {
      selectedElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onCloseAdult = (value: boolean) => {
    setIsCheckAdult(true);
    setVisibleConfirm(value);
  };

  // 카테고리
  const renderCategoryList = () => {
    return (
      <>
        {menuInfo.map((item: CategoryType, index: number) => {
          return (
            <div
              key={index}
              className={`product ${selectedCategory === index && "active"}`}
              onClick={() => {
                selectCategory(index);

                try {
                  LogController.click({
                    path: "MenuInfo",
                    params: "category",
                    params2: `${storeInfo?.store_name}: ${item.category_name}`,
                    index: item.category_id,
                  });
                } catch (err) {
                  console.log(err);
                }
              }}
            >
              <h2
                className={`categoryName ${
                  selectedCategory === index && "active"
                }`}
              >
                {getCategoryName(item, lang)}
              </h2>
              {item.is_for_adult === 1 && (
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_adult.svg`}
                  alt="주류"
                />
              )}
            </div>
          );
        })}
        {/* 매장소개 */}
        <div
          className={`product ${
            selectedCategory === menuInfo.length && "active"
          }`}
          onClick={() => selectCategory(menuInfo.length)}
        >
          <h2
            className={`categoryName ${
              selectedCategory === menuInfo.length && "active"
            }`}
          >
            {langText.menuInfo_category_storeInfo[lang]}
          </h2>
        </div>
      </>
    );
  };

  const onClickProductItem = async (
    product: ProductType,
    is_for_adult: number,
    isDescription: boolean,
    event?: any
  ) => {
    try {
      LogController.click({
        path: "MenuInfo",
        params: "product",
        params2: `${storeInfo?.store_name}: ${product.prd_name}`,
        index: product.prd_id,
      });
    } catch (err) {
      console.log(err);
    }

    if (product.is_soldout === 0) {
      PlayClickAudio();
      if (product.is_set === 0) {
        try {
          if (isDescription && event) {
            await onClickDescription(product, is_for_adult, event);
          } else {
            await onClickProduct(product, is_for_adult);
          }
        } catch (error) {
          console.error("메뉴클릭 error:", error);
        }
      } else {
        try {
          await onClickSetProduct(product, is_for_adult);
        } catch (error) {
          console.error("세트메뉴클릭 error:", error);
        }
      }
    }
  };

  const onChangeStoreInfoIndex = (arrayIndex: number, index: number) => {
    let storeImageTemp = storeInfoIndex;
    storeImageTemp[arrayIndex] = index;
    setStoreInfoIndex([...storeImageTemp]);
  };

  // 상품
  const onClickProduct = async (product: ProductType, is_for_adult: number) => {
    setSelectedProduct(product);
    let response = await ApiController.menu.getOptions(product.prd_id, storeId);
    if (response.ok) {
      let serverOptionGroupList = response.data;
      console.log("get options", serverOptionGroupList);
      setOptionGroupList(serverOptionGroupList);
      console.log("serverOptionGroupList일반", serverOptionGroupList.length);

      if (serverOptionGroupList.length > 0) {
        setIsOptionModalVisible(true);
      }

      // 옵션도 상세설명도 없을때
      else {
        if (cart.length > 0 && cart[0].store_id !== storeId) {
          setConfirmState({
            visibleConfirm: true,
            successText: langText.button_add_new[lang],
            cancelText: langText.button_cancel[lang],
            handleConfirm: () => {
              OrderController.deleteCart();
              if (selectedProduct) {
                OrderController.addCart(
                  storeId,
                  product,
                  menuInfo[selectedCategory].category_id,
                  [],
                  [],
                  showToast
                );
              }
            },
            title: langText.menuInfo_other_store[lang],
          });
        } else {
          OrderController.addCart(
            storeId,
            product,
            menuInfo[selectedCategory].category_id,
            [],
            [],
            showToast
          );
        }
      }
      if (is_for_adult === 1 && !isCheckAdult) setVisibleConfirm(true);
      // }
      // else if (
      //   product.prd_type === PRODUCT_TYPE_RENTAL_DIRECT ||
      //   product.prd_type === PRODUCT_TYPE_RENTAL_SMS
      // ) {
      //   setRentalOptionModalVisible(true);
      // }
    } else {
      // console.log("토스트메시지: 옵션 불러오기 실패");
    }
  };

  const onClickDescription = async (
    product: ProductType,
    is_for_adult: number,
    event: any
  ) => {
    event.stopPropagation();
    setSelectedProduct(product);
    let response = await ApiController.menu.getOptions(product.prd_id, storeId);
    if (response.ok) {
      let serverOptionGroupList = response.data;
      console.log("get options", serverOptionGroupList);
      setOptionGroupList(serverOptionGroupList);
      console.log("serverOptionGroupList일반", serverOptionGroupList.length);

      if (serverOptionGroupList.length > 0) {
        setIsOptionModalVisible(true);
      }
      // 옵션은 없지만 상세설명이 있을때
      else if (
        serverOptionGroupList.length === 0 &&
        product.prd_description !== null &&
        product.prd_description.length > 0
      ) {
        setIsProductDetailModalVisible(true);
      }
      if (is_for_adult === 1 && !isCheckAdult) setVisibleConfirm(true);
    }
  };

  // 세트상품
  const onClickSetProduct = async (
    product: ProductType,
    is_for_adult: number
  ) => {
    setSelectedProduct(product);

    let response = await ApiController.menu.getSetOptions(
      product.prd_id,
      storeId
    );

    if (response.ok) {
      let serverOptionGroupList = response.data;

      if (
        serverOptionGroupList !== undefined &&
        serverOptionGroupList !== null
      ) {
        setSetMenuGroupList(serverOptionGroupList);
        setSetOptionModalVisible(true);
        console.log("세트상품모달");
      }
    }

    if (is_for_adult === 1 && !isCheckAdult) setVisibleConfirm(true);
  };
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const renderProductList = () => {
    return (
      <div className="menu" ref={scrollRef}>
        {menuInfo.map((item: CategoryType, category_index: number) => {
          return (
            menuInfo?.length > 0 && (
              <div className="menuWrapper" key={category_index}>
                <div className="productWrapper">
                  {item.product_list.map(
                    (product: ProductType, product_index: number) => {
                      return (
                        <div
                          ref={childRef}
                          key={product_index}
                          className={`itemWrapper`}
                          onClick={() => {
                            onClickProductItem(
                              product,
                              item.is_for_adult,
                              false
                            );
                          }}
                        >
                          <div className="prdInfoWrap">
                            <div className="badgeWrap">
                              {product.badge_list.length > 0 &&
                                product.badge_list.map((badge: badgeType) => (
                                  <div
                                    className="badge"
                                    style={{
                                      background: badge.badge_background,
                                    }}
                                  >
                                    <p>{contentName(badge.badge_name, lang)}</p>
                                  </div>
                                ))}
                              {product.is_set === 1 && (
                                <div className="badge set">
                                  <p>SET MENU</p>
                                </div>
                              )}
                              {product.confirm_type === 2 && (
                                <div className="badge autoConfirm">
                                  <p>
                                    {langText.menuInfo_badge_autoConfirm[lang]}
                                  </p>
                                </div>
                              )}
                            </div>
                            <div className="prdTitleWrap">
                              <h2 className="name">
                                {getPrdName(product, lang)}
                              </h2>
                              <div>
                                <h2>{product.prd_base_price_nrm}원</h2>
                                {product.prd_discount_percentage !== 0 && (
                                  <div className="discountWrap">
                                    <h4>{product.prd_org_price_nrm}원</h4>
                                    <span>
                                      {product.prd_discount_percentage}%
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="prdDescriptionWrap">
                              {getPrdDescription(product, lang) && (
                                <h5>{getPrdDescription(product, lang)}</h5>
                              )}
                            </div>
                          </div>
                          <div className="imgWrap">
                            {product.url_path !== null ? (
                              <img
                                className="menuImg"
                                src={product.url_path}
                                alt="메뉴이미지"
                                width={"100%"}
                              />
                            ) : product.prd_type === PRODUCT_TYPE_EXTENSION ? (
                              <img
                                src={`${process.env.PUBLIC_URL}/knockknock/img/CheckoutExtension.png`}
                                alt="연장"
                                width={"100%"}
                                className={`menuImg`}
                                style={{ filter: "brightness(0.7)" }}
                              />
                            ) : (
                              <div className="menuImg" />
                            )}
                            {/* 연장 상품 */}
                            {product.prd_type === PRODUCT_TYPE_EXTENSION &&
                              product.hour_extension && (
                                <div className="soldOutWrap">
                                  <h2>{product.hour_extension}시간</h2>
                                </div>
                              )}
                            {/* 품절시 */}
                            {product.is_soldout === 1 && (
                              <div className="soldOutWrap">
                                <h2>SOLD OUT</h2>
                              </div>
                            )}
                            {getPrdDescription(product, lang) && (
                              <button
                                className="detailButton"
                                onClick={(event) =>
                                  onClickProductItem(
                                    product,
                                    item.is_for_adult,
                                    true,
                                    event
                                  )
                                }
                              >
                                <p>{langText.menuInfo_badge_detail[lang]}</p>
                              </button>
                            )}
                            <img
                              className="addIcon"
                              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_add.svg`}
                              alt="추가하기"
                            />
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            )
          );
        })}
        {/* 선택된 상품의 상세 내용을 표시하는 부분 */}
        {selectedProduct && (
          <div className="storeDetailWrap">
            {storeDetailInfo.map((item: storeDetailType, index: number) => {
              // console.log(storeInfoIndex, storeDetailInfo.length);
              return (
                <>
                  {item.store_image.length > 0 && (
                    <div className="storeContent" key={index}>
                      <div className="storeInfoContent">
                        <h4 className="title">
                          {langText.menuInfo_store_info[lang]}
                        </h4>
                      </div>
                      <Slider
                        className="slider"
                        {...settings}
                        afterChange={(imgIndex: number) => {
                          onChangeStoreInfoIndex(index, imgIndex);
                        }}
                      >
                        {item.store_image.map(
                          (obj: storeImageType, index: number) => {
                            return (
                              <img
                                key={index}
                                className="storeDetailImage"
                                src={obj.url_path}
                                alt="img"
                              />
                            );
                          }
                        )}
                      </Slider>
                      <div className="imageCount">
                        <p>
                          {storeInfoIndex[index] + 1} /{" "}
                          {item.store_image.length}
                        </p>
                      </div>
                    </div>
                  )}
                  <p className="storeContentText">
                    {getStoreDetail(item, lang)}
                  </p>
                </>
              );
            })}
            {storeInfo && (
              <>
                <div className="storeInfoContent">
                  <h4 className="title">
                    {langText.menuInfo_delivery_info[lang]}
                  </h4>
                  <p>
                    <span>{langText.menuInfo_delivery_time[lang]}</span>
                    {storeInfo.delivery_estimated_time}
                    {langText.minute[lang]}
                  </p>
                  <p style={{ alignItems: "flex-start", lineHeight: "24px" }}>
                    <span>
                      {langText.paymentListModal_title_delivery_cost[lang]}
                    </span>
                    {storeInfo.limit_order_price > 0
                      ? `- ${
                          langText.paymentListModal_title_orderAmount[lang]
                        } ${storeInfo.limit_order_price.toLocaleString()}원 ${
                          langText.more_price[lang]
                        } `
                      : ``}
                    {storeInfo.base_delivery_price > 0
                      ? `- ${
                          langText.paymentListModal_title_delivery_cost[lang]
                        } ${storeInfo.base_delivery_price.toLocaleString()}원`
                      : `${langText.delivery_price_free[lang]}`}
                    {storeInfo.delivery_price.map(
                      (obj) =>
                        `\r\n- ${
                          langText.paymentListModal_title_orderAmount[lang]
                        } ${obj.more_order_price.toLocaleString()}원 ${
                          langText.more_price[lang]
                        } ${
                          langText.paymentListModal_title_delivery_cost[lang]
                        } ${obj.more_delivery_price.toLocaleString()}원`
                    )}
                  </p>
                  <p>
                    <span>{langText.menuInfo_base_delivery_price[lang]}</span>
                    {storeInfo.limit_order_price > 0
                      ? `${storeInfo.limit_order_price.toLocaleString()}원`
                      : `${langText.menuInfo_none[lang]}`}
                  </p>
                  {storeInfo.description_business_time !== null && (
                    <p>
                      <span>{langText.menuInfo_business_time[lang]}</span>
                      {storeInfo.description_business_time}
                    </p>
                  )}
                </div>
                <div className="storeInfoDetail">
                  {storeInfo.description_event !== "" &&
                    storeInfo.description_event !== null && (
                      <div className="storeInfoContent">
                        <h4 className="title">
                          {langText.menuInfo_event[lang]}
                        </h4>
                        <p>{getStoreEvent(storeInfo, lang)}</p>
                      </div>
                    )}
                  {storeInfo.description_noti !== "" &&
                    storeInfo.description_noti !== null && (
                      <div className="storeInfoContent">
                        <h4 className="title">
                          {langText.menuInfo_notification[lang]}
                        </h4>
                        <p>{getStoreNoti(storeInfo, lang)}</p>
                      </div>
                    )}
                  <div className="storeInfoContent">
                    <h4 className="title">
                      {langText.menuInfo_origin_info[lang]}
                    </h4>
                    <p>{storeInfo.description_extra}</p>
                  </div>
                </div>
                <div className="storeInfo">
                  <div className="storeInfoContent">
                    <h4 className="title">{langText.call[lang]}</h4>

                    <p>
                      <span>{langText.menuInfo_store_tel[lang]}</span>
                      {formatPhoneNumber(storeInfo.phone_number)}
                    </p>
                    <p>
                      <span>{langText.menuInfo_address[lang]}</span>
                      {storeInfo.address1} {storeInfo.address2}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    );
  };

  // 메뉴 상세설명
  const RenderProductDetail = () => {
    return (
      <div className="productDetailWrap">
        <div className="detailImgWrap">
          {selectedProduct?.url_path ? (
            <div>
              <img
                className="detailImg"
                src={selectedProduct?.url_path}
                alt="상품 이미지"
              />
            </div>
          ) : (
            <div>
              <img
                className="detailImg"
                src={`${process.env.PUBLIC_URL}/knockknock/img/noneMenuImage.png`}
                alt="상품 이미지 없음"
              />
            </div>
          )}
        </div>
        <div className="detailTextWrap">
          <div className="detailTextTitle">
            {selectedProduct && (
              <h2 className="detailName">
                {getPrdName(selectedProduct, lang)}
              </h2>
            )}
            <h2 className="detailPrice">
              {selectedProduct?.prd_base_price_nrm}원
            </h2>
          </div>
          {selectedProduct?.prd_description && (
            <p>{getPrdDescription(selectedProduct, lang)}</p>
          )}
        </div>
      </div>
    );
  };

  // 카트 담기
  const addCartOptionModal = () => {
    for (let i = 0; i < optionGroupList.length; i++) {
      let optionGroup = optionGroupList[i];

      if (
        (optionGroup.option_input_max === 1 &&
          optionGroup.option_input_min === 1) ||
        (optionGroup.option_input_max === 0 &&
          optionGroup.option_input_min === 0)
      ) {
        if (selectedOption[i].length !== 1) {
          showToast(langText.menuInfo_title_optionRequired[lang], "error");
          return false;
        }
      } else {
        if (
          optionGroup.option_input_min > selectedOption[i].length ||
          optionGroup.option_input_max < selectedOption[i].length
        ) {
          showToast(langText.menuInfo_title_optionRequired[lang], "error");
          return false;
        }
      }
    }

    if (selectedProduct) {
      console.log("=================================>옵션있음");
      if (cart.length > 0 && cart[0].store_id !== storeId) {
        setConfirmState({
          visibleConfirm: true,
          successText: langText.button_add_new[lang],
          cancelText: langText.button_cancel[lang],
          handleConfirm: () => {
            OrderController.deleteCart();
            if (selectedProduct) {
              OrderController.addCart(
                storeId,
                selectedProduct,
                menuInfo[selectedCategory].category_id,
                optionGroupList,
                selectedOption,
                showToast,
                (selectedProduct.prd_type === PRODUCT_TYPE_RENTAL_DIRECT ||
                  selectedProduct.prd_type === PRODUCT_TYPE_RENTAL_SMS) &&
                  rentalTime
                  ? rentalTime
                  : undefined
              );
            }
          },
          title: langText.menuInfo_other_store[lang],
        });
      } else {
        OrderController.addCart(
          storeId,
          selectedProduct,
          menuInfo[selectedCategory].category_id,
          optionGroupList,
          selectedOption,
          showToast,
          (selectedProduct.prd_type === PRODUCT_TYPE_RENTAL_DIRECT ||
            selectedProduct.prd_type === PRODUCT_TYPE_RENTAL_SMS) &&
            rentalTime
            ? rentalTime
            : undefined
        );
      }

      setIsOptionModalVisible(false);

      if (
        (selectedProduct.prd_type === PRODUCT_TYPE_RENTAL_DIRECT ||
          selectedProduct.prd_type === PRODUCT_TYPE_RENTAL_SMS) &&
        rentalTime
      ) {
        setRentalTime({
          option_type_name: "",
          option_name: "",
        });
        setRentalOptionModalVisible(false);
      }
    }
  };

  // 세트 담기
  const addCartSetOptionModal = (pick: pickGroupListType[]) => {
    //TODO 1. 상품 구성의 상품선택 검증
    console.log("=======");
    console.log(pick);
    console.log("=======");

    for (let i = 0; i < pick.length; i++) {
      //필수선택을 다 하지 않은경우
      if (pick[i].input_min > pick[i].pick.length) {
        showToast(
          `${lang === LANG_KO || lang === LANG_JP ? i + 1 : ""}${
            langText.menuInfo_toast_select_source[lang]
          }${lang !== LANG_KO && lang !== LANG_JP ? i + 1 : ""}`
        );
        return;
      } else if (pick[i].pick.length > pick[i].input_max) {
        //프론트 화면로직상 해당 토스트는 발생 안하지만 에러처리
        showToast(`error configuration ${i + 1}`);
        return;
      }
    }

    //TODO 2. 선택된 상품의 옵션 검증
    for (let i = 0; i < pick.length; i++) {
      const productGroupPickList = pick[i];
      const productPickList = pick[i].pick;
      for (let j = 0; j < productPickList.length; j++) {
        const productPick = productPickList[j];
        const optionGroupPick = productPickList[j].pick;
        const optionGroupList = productPickList[j].option_group_list;

        for (let k = 0; k < optionGroupPick.length; k++) {
          const optionPick = optionGroupPick[k];
          const optionCurrentGroup = optionGroupList[k];

          if (optionCurrentGroup.option_input_min > optionPick.length) {
            if (productGroupPickList.input_min > 0) {
              showToast(
                `${langText.menuInfo_toast_set_option_1[lang]}${
                  lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                    ? i + 1
                    : optionCurrentGroup.option_input_min
                }${langText.menuInfo_toast_set_option_2[lang]}${
                  lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                    ? getPrdName(productPick, lang)
                    : getOptionTypeName(optionCurrentGroup, lang)
                }${langText.menuInfo_toast_set_option_3[lang]}${
                  lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                    ? getOptionTypeName(optionCurrentGroup, lang)
                    : getPrdName(productPick, lang)
                }${langText.menuInfo_toast_set_option_4[lang]}${
                  lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                    ? optionCurrentGroup.option_input_min
                    : i + 1
                }${langText.menuInfo_toast_set_option_5[lang]}`,
                undefined,
                3000
              );
            } else {
              showToast(
                `${langText.menuInfo_toast_setOption_option_1[lang]}${
                  lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                    ? getOptionTypeName(optionCurrentGroup, lang)
                    : optionCurrentGroup.option_input_min
                }${langText.menuInfo_toast_setOption_option_2[lang]}${
                  lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                    ? optionCurrentGroup.option_input_min
                    : getOptionTypeName(optionCurrentGroup, lang)
                }${langText.menuInfo_toast_setOption_option_3[lang]}`,
                undefined,
                3000
              );
            }

            return;
          } else if (optionPick.length > optionCurrentGroup.option_input_max) {
            //프론트 화면로직상 해당 토스트는 발생 안하지만 에러처리
            showToast(
              `구성 ${i + 1}의 ${productPick.prd_name}상품의 ${
                optionCurrentGroup.option_type_name
              }의 옵션이 많이 선택됨`
            );
            return;
          }
        }
      }
    }

    //TODO 3. store_id 검증

    if (selectedProduct) {
      if (cart.length > 0 && cart[0].store_id !== storeId) {
        setConfirmState({
          visibleConfirm: true,
          successText: langText.button_add_new[lang],
          cancelText: langText.button_cancel[lang],
          handleConfirm: () => {
            OrderController.deleteCart();
            if (selectedProduct) {
              // showToast(`${langText.menuInfo_toast_added[lang]}`);
              OrderController.addSetCart(
                storeId,
                selectedProduct,
                menuInfo[selectedCategory].category_id,
                pick
              );
              // OrderController.addCart(
              //   storeId,
              //   selectedProduct,
              //   menuInfo[selectedCategory].category_id,
              //   optionGroupList,
              //   selectedOption
              // );
            }
          },
          title: langText.menuInfo_other_store[lang],
        });
      } else {
        // showToast(`${langText.menuInfo_toast_added[lang]}`);
        OrderController.addSetCart(
          storeId,
          selectedProduct,
          menuInfo[selectedCategory].category_id,
          pick
        );
        // OrderController.addCart(
        //   storeId,
        //   selectedProduct,
        //   menuInfo[selectedCategory].category_id,
        //   optionGroupList,
        //   selectedOption
        // );
      }

      setSetOptionModalVisible(false);
    }
  };
  // 매장이동하면 화면 맨위로 이동
  useEffect(() => {
    if (scrollTop && scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: "auto",
      });
      return setScrollTop(false);
    }
  }, [scrollTop]);
  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        const parentRect = scrollRef.current.getBoundingClientRect();
        const children = scrollRef.current.children;

        for (let i = 0; i < children.length; i++) {
          const childRect = (
            children[i] as HTMLElement
          ).getBoundingClientRect();

          const selectedIndex = selectedCategory;

          if (!isScroll) {
            if (childRect.bottom >= parentRect.top) {
              setSelectedCategory(i);
              break;
            }
          } else {
            if (
              i === selectedIndex &&
              Math.abs(childRect.top - parentRect.top) < 1
            ) {
              setIsScroll(false);
              console.log("selected scroll end");
              break;
            }
          }
        }
      }
    };

    const scrollElement = scrollRef.current;

    console.log("scrollRef", scrollRef, menuInfo);

    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => {
        scrollElement.removeEventListener("scroll", handleScroll);
      };
    }
  }, [menuInfo, isScroll]);

  useEffect(() => {
    setStoreInfoIndex(new Array(storeDetailInfo.length).fill(0));
  }, [storeDetailInfo]);

  return (
    <>
      <Style>
        <div
          className={`menuContent ${
            location.pathname.includes(`/store/${storeId}`) && "preview"
          }`}
        >
          <div className="category">{renderCategoryList()}</div>
          {renderProductList()}
          <SelectOptionModal
            isVisible={isOptionModalVisible}
            setVisible={setIsOptionModalVisible}
            setSelectedProduct={setSelectedProduct}
            option={optionGroupList}
            RenderProductDetail={RenderProductDetail}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            addCart={addCartOptionModal}
            resetTimer={resetTimer}
          />
          <SelectSetOptionModal
            isVisible={setOptionModalVisible}
            setVisible={setSetOptionModalVisible}
            setSelectedProduct={setSelectedProduct}
            setMenuGroup={setMenuGroupList}
            RenderProductDetail={RenderProductDetail}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            addCart={addCartSetOptionModal}
            resetTimer={resetTimer}
          />
          <RentalOptionModal
            isVisible={rentalOptionModalVisible}
            setVisible={setRentalOptionModalVisible}
            setSelectedProduct={setSelectedProduct}
            option={optionGroupList}
            RenderProductDetail={RenderProductDetail}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            addCart={addCartOptionModal}
            resetTimer={resetTimer}
            selectedProduct={selectedProduct!}
            rentalTime={rentalTime}
            setRentalTime={setRentalTime}
          />

          <ProductDetailModal
            isVisible={isProductDetailModalVisible}
            setVisible={setIsProductDetailModalVisible}
            RenderProductDetail={RenderProductDetail}
            {...{ selectedProduct, setSelectedProduct }}
            addCart={() => {
              // if()
              if (selectedProduct) {
                if (cart.length > 0 && cart[0].store_id !== storeId) {
                  setConfirmState({
                    visibleConfirm: true,
                    successText: langText.button_add_new[lang],
                    cancelText: langText.button_cancel[lang],
                    handleConfirm: () => {
                      OrderController.deleteCart();
                      if (selectedProduct) {
                        OrderController.addCart(
                          storeId,
                          selectedProduct,
                          menuInfo[selectedCategory].category_id,
                          [],
                          [],
                          showToast
                        );
                      }
                    },
                    title: langText.menuInfo_other_store[lang],
                  });
                } else {
                  OrderController.addCart(
                    storeId,
                    selectedProduct,
                    menuInfo[selectedCategory].category_id,
                    [],
                    [],
                    showToast
                  );
                }

                setIsProductDetailModalVisible(false);
              }
            }}
            resetTimer={resetTimer}
          />
        </div>
      </Style>
      <ConfirmModal
        isVisible={visibleConfirm}
        setVisible={onCloseAdult}
        title={langText.confirmModal_alcohol[lang]}
        confirmText={langText.button_confirm[lang]}
        icon={`${process.env.PUBLIC_URL}/knockknock/svg/ic_adult.svg`}
      />
    </>
  );
};
export default MenuInfo;

const Style = styled.div`
  /* menuWrap */
  .storeInfoContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 50px;

    h4 {
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
    h4.title {
      width: 100%;
      text-align: center;
      padding: 8px 0;
      border-top: 1px solid #ffffff;
      border-bottom: 1px solid #ffffff;
      font-weight: 600;
    }
    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 18px;
      word-break: keep-all;
      display: flex;
      align-items: center;
    }
    span {
      display: inline-block;
      width: 130px;
      font-weight: 600;
    }
  }

  .menuContent {
    height: calc(100vh - 480px);
    display: flex;
  }

  .menuContent.preview {
    height: 80vh;
  }

  /* 카테고리 */
  .category {
    width: 20%;
    height: 100%;
    overflow: auto;
  }

  .product {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 10px;
    border: 1px solid #4d4d4d;
    border-left: none;
    background: #262626;

    img {
      height: 28px;
    }
  }

  .product.active {
    padding: 6px 10px;
    border: 5px solid #4dd2ae;
    border-left: none;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .product:nth-child(1) {
    border-top-right-radius: 6px;
  }
  .product:last-of-type {
    border-bottom-right-radius: 6px;
  }
  .categoryName {
    font-size: 20px;
    line-height: 24px;
    font-weight: 300;
    margin: 10px 0;
    color: #eee;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .categoryName.active {
    font-weight: 600;
    color: #4dd2ae;
  }

  /* 메뉴 */
  .menu {
    height: 100%;
    flex: 1;
    overflow-y: scroll;
    box-sizing: border-box;
    padding: 0 20px;
  }
  .itemWrapper {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 0;
    border-bottom: 2px solid #262626;
    text-align: center;
  }

  .prdInfoWrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0 20px;
    .badgeWrap {
      display: flex;
      align-items: center;
      gap: 8px;
      height: 30px;
      .badge {
        padding: 2px 10px 2px 10px;
        border-radius: 50px;
        text-align: center;
        z-index: 2;

        p {
          font-size: 14px;
          line-height: 18px;
          font-weight: 600;
          color: #ffffff;
        }
      }
      .badge.set {
        padding: 1px 9px;
        border: 1px solid #979797;
        background: #262626;
      }
      .badge.autoConfirm {
        background: #ff4a4a;
      }
    }

    @keyframes flowRight {
      0% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
      }
      100% {
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
      }
    }

    .prdTitleWrap {
      width: 100%;
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      h2 {
        width: 120px;
        font-size: 24px;
        line-height: 32px;
        color: #fff;
        font-weight: 600;
        white-space: nowrap;
        word-break: break-all;
      }
      h2.name {
        flex: 1;
        max-width: 260px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .prdDescriptionWrap {
      width: 100%;
      height: 40px;
      text-align: left;
      h5 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 14px;
        line-height: 20px;
        color: #a7a7a7;
        font-weight: 300;
        overflow: hidden;
        word-break: break-word;
        text-overflow: ellipsis;
      }
    }
  }

  .imgWrap {
    position: relative;
    .detailButton {
      position: absolute;
      right: 4px;
      top: 4px;
      padding: 3px 10px;
      border-radius: 50px;
      background: #cccccc;
      z-index: 1;
      p {
        font-size: 14px;
        line-height: 16px;
        color: #fff;
        font-weight: 600;
      }
    }
    .addIcon {
      position: absolute;
      right: 4px;
      bottom: 8px;
    }
  }
  .menuImg {
    width: 150px;
    height: 120px;
    border-radius: 5px;
  }

  .soldOutWrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 5px;

    h2 {
      height: 100%;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-weight: 600;
    }
  }
  .clickBackground {
    width: 100%;
    height: 100%;
    position: absolute;
    background: red;
    top: 0;
    opacity: 0;
  }
  .clickBackground.active {
    opacity: 0.5;
  }
  .discountWrap {
    display: flex;
    align-items: center;
    justify-content: center;

    h4 {
      margin-right: 6px;
      font-size: 14px;
      font-weight: 600;
      color: #555;
      text-decoration: line-through;
    }
    span {
      font-size: 14px;
      font-weight: 700;
      color: #ff0000;
    }
  }

  /* 매장소개 */
  .storeDetailWrap {
    padding-top: 50px;
    h2 {
      padding: 8px 0 0 0;
    }
  }
  .storeInfo {
    .storeInfoContent {
      margin-bottom: 40px;
    }
  }
  .storeContent {
    position: relative;

    .slider {
      width: 100%;
      height: 280px;
    }
    .storeDetailImage {
      width: 100%;
      height: 280px;
      object-fit: cover;
    }

    .imageCount {
      position: absolute;
      bottom: 15px;
      right: 21px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50px;

      p {
        padding: 3px 14px 2px 14px;
        margin: 0;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
  .storeContentText {
    margin-bottom: 50px;
    margin-top: 10px;
    font-size: 16px;
    font-weight: 400;
    line-height: 25px;
    word-break: keep-all;
  }
`;
